import React, { useEffect, useState } from "react";
import BranchProfileForm from "../components/branch-form";
import { Breadcrumbs, Button, Modal } from "../../../../components/core";
import { useDispatch, useSelector } from "react-redux";
import {
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { getPartnerList } from "../../../../features/branches/add-branch-slice";
import {
  PARTNER_CATEGORY,
  SEARCH_PARTNERS_FOR_TABLE,
} from "../../../../constants/graphql/partners-query";
import { Strings } from "../../../../constants/strings";
import {
  CREATE_BRANCH,
  GET_HEAD_OFFICE_BY_PARTNER_ID,
} from "../../../../constants/graphql/branch-queries";

const AddNewBranch = () => {
  const breadcrumbItems = [
    {
      label: "Branches",
      path: `/branches/`,
    },
    { label: "Add Branch", path: "#" },
  ];
  const operatorId = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).operator_id
    : null;

  //   utils
  const dispatch = useDispatch();
  const client = useApolloClient();
  const navigate = useNavigate();

  //   selectors
  const partnerList = useSelector((state) => state.addBranch.partnerList);

  //   local variables
  const [branchProfile, setBranchProfile] = useState({
    operatorId: operatorId,
    branchLevel: 1,
    partnerCategoryNo: "-1",
    partnerId: "",
    partnerBranch: "",
    address: "",
    contactPerson: "",
    contactPerson2: "",
    contactPosition: "",
    contactPosition2: "",
    zipCode: "",
    landline: "",
    landline2: "",
    mobile: "",
    mobile2: "",
    email: "",
    email2: "",
    remarks: "",
  });
  const [partnerCategoryItems, setPartnerCategoryItems] = useState([]);
  const contactPersonFields = [
    {
      index: 1,
      suffix: "",
      fields: {
        contactPerson: "contactPerson",
        contactPosition: "contactPosition",
        mobile: "mobile",
        email: "email",
        landline: "landline",
      },
    },
    {
      index: 2,
      suffix: "2",
      fields: {
        contactPerson: "contactPerson2",
        contactPosition: "contactPosition2",
        mobile: "mobile2",
        email: "email2",
        landline: "landline2",
      },
    },
  ];
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [changesMade, setChangesMade] = useState(false);
  const [headOfficeExists, setHeadOfficeExists] = useState(false);

  //   gql
  const partners = useQuery(SEARCH_PARTNERS_FOR_TABLE, {
    variables: {
      operatorId: operatorId,
      ...(branchProfile.partnerCategoryNo !== "-1" && {
        partnerCategoryId: branchProfile.partnerCategoryNo,
      }),
    },
  });
  const partnerCategory = useQuery(PARTNER_CATEGORY);
  const [createBranch] = useMutation(CREATE_BRANCH);
  const [findHeadOffice, { data: headOfficeData }] = useLazyQuery(
    GET_HEAD_OFFICE_BY_PARTNER_ID
  );
  //   use Effects
  useEffect(() => {
    if (partners.data) {
      let tempVar = [];
      partners.data.searchCouriers.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      dispatch(getPartnerList(tempVar));
    }
  }, [partners.data]);
  useEffect(() => {
    if (partnerCategory.data) {
      var tempArr = [];
      partnerCategory.data.partnerCategories.forEach((element) => {
        tempArr.push({
          value: element.partnerCategoryNo,
          name: element.partnerCategory,
        });
      });
      setPartnerCategoryItems(tempArr);
    }
  }, [partnerCategory.data]);

  useEffect(() => {
    if (branchProfile.partnerId !== "") {
      findHeadOffice({
        variables: {
          partnerId: branchProfile.partnerId,
        },
      });
    }
  }, [branchProfile.partnerId]);

  useEffect(() => {
    if (
      headOfficeData &&
      headOfficeData.getHeadOfficeByPartnerId !== undefined
    ) {
      let headOfficeIdentifier =
        headOfficeData.getHeadOfficeByPartnerId.length > 0;

      // if (headOfficeIdentifier) {
      setHeadOfficeExists(headOfficeIdentifier);
    }
  }, [headOfficeData?.getHeadOfficeByPartnerId]);

  // wrong logic
  // useEffect(() => {
  //   if (headOfficeExists) {
  //     setBranchProfile({
  //       ...branchProfile,
  //       branchLevel: 0,
  //     });
  //   }
  // }, [headOfficeExists]);

  const handleOnChange = (event) => {
    const { name, value, checked } = event.target;
    console.log({ branchProfile, value });

    if (
      name === "tinNumber" ||
      name === "zipCode" ||
      name === "mobile" ||
      name === "mobile2" ||
      name === "landline" ||
      name === "landline2"
    ) {
      // const tinRegex = /^\d+$/;
      const tinRegex = /^\d*$/;
      if (!tinRegex.test(value)) {
        setChangesMade(false);
        return; // Exit if the validation fails
      }
    }

    if (name === "branchLevel") {
      // 0 is head Office
      // 1 is a normal branch
      let computedValue = value === 1 || value === "1" ? 0 : 1;
      // if (value === "on") {
      setBranchProfile({
        ...branchProfile,
        branchLevel: computedValue,
      });
      setChangesMade(true);
      return;
      // }
    }

    // Refetch partner types for partnerCategoryNo
    if (name === "partnerCategoryNo") {
      partners.refetch({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        partnerCategoryId: value,
      });
      setHeadOfficeExists(false);
      setBranchProfile({
        ...branchProfile,
        partnerId: "",
        branchLevel: 1, // Clear branchlevel when partnerCategoryNo changes
        partnerCategoryNo: value,
      });
      setChangesMade(true);
      return; // Exit early to avoid the general update below
    }

    // Clear branchlevel when partnerId changes
    if (name === "partnerId") {
      setBranchProfile({
        ...branchProfile,
        partnerId: value,
        branchLevel: 1, // Clear branchlevel when partnerId changes
      });
      setChangesMade(true);
      return; // Exit early to avoid the general update below
    }

    // General field update for other fields
    setBranchProfile({
      ...branchProfile,
      [name]: value,
    });
    // Dispatch the change
    // dispatch(onPartnerProfileDataChange({ name, value, checked }));
    setChangesMade(true);
  };
  const showValidationError = (message) => {
    setValidation({
      icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
      title: Strings.popup_error_title,
      message,
      open: true,
      actions: (
        <div className="grid grid-cols-1 gap-2">
          <Button
            value={"OK"}
            className={"p-2"}
            onClick={() => setValidation(false)}
          />
        </div>
      ),
    });
  };

  const handleValidateFields = () => {
    const updatedData = { ...branchProfile };
    let emailRegex = /^[a-zA-Z0-9._%+-ñÑ]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Simple validation checks with early returns
    if (updatedData.partnerCategoryNo === "-1")
      return showValidationError("Partner Category is a required field");

    if (updatedData.partnerId === "-1")
      return showValidationError("Partner is a required field");

    if (updatedData.partnerBranch === "")
      return showValidationError("Partner Branch is a required field");

    if (updatedData.contactPerson === "" || updatedData.contactPerson2 === "")
      return showValidationError("Contact Name is a required field");

    if (
      updatedData.contactPosition === "" ||
      updatedData.contactPosition === ""
    )
      return showValidationError("Contact Position is a required field");

    if (updatedData.mobile !== "" || updatedData.mobile2 !== "") {
      if (updatedData.mobile.length < 10 || updatedData.mobile2.length < 10) {
        return showValidationError("Please enter a valid mobile number");
      }
      if (
        !updatedData.mobile.startsWith("9") ||
        !updatedData.mobile2.startsWith("9")
      ) {
        return showValidationError("Invalid mobile number format");
      }
    } else {
      return showValidationError("Contact Mobile is a required field");
    }

    if (updatedData.email === "" || updatedData.email2 === "")
      return showValidationError("Contact Email is a required field");

    if (
      (updatedData.email !== "" && !emailRegex.test(updatedData.email)) ||
      (updatedData.email2 !== "" && !emailRegex.test(updatedData.email2))
    )
      return showValidationError("Please provide a valid email address");

    if (updatedData.landline === "" || updatedData.landline2 === "")
      return showValidationError("Contact Landline is a required field");
    else {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: Strings.popup_confirm_save_title,
        message: Strings.popup_confirm_save_massage,
        open: true,
        actions: (
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"No"}
              className={"p-2 w-full"}
            />
            <Button
              onClick={handleSaveChanges}
              value={"Yes"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
    }
  };

  const handleCancelChanges = () => {
    // dispatch(onClearDataReducer());
    // console.log(partnerProfileData.address);
    // setOpenCancelModal(false);
    navigate(`/branches`);
  };

  const handleSaveChanges = () => {
    const updatedData = {
      ...branchProfile,
      mobile: "63" + branchProfile.mobile,
      mobile2: "63" + branchProfile.mobile2,
      zipCode: 1,
      // branchLevel: branchProfile.branchLevel === "" ? 1 : 0,
    };
    delete updatedData.partnerCategoryNo;

    client.clearStore();
    createBranch({ variables: { branches: [updatedData] } })
      .then((data) => {
        if (data.data) {
          const partnerBranchId =
            data.data.createBranch.partnerBranch.partnerBranchId;
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_add,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => {
                    setValidation(false);
                    navigate(`/branches/edit-branch/${partnerBranchId}`);
                  }}
                />
              </div>
            ),
          });
          client.clearStore();
        }
      })
      .catch((e) => {
        if (e.message.includes("duplicate")) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_duplicate,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        } else if (
          e.message.includes(
            'duplicate key value violates unique constraint "partner_branches__partner_branch_head"\nDETAIL:  Key (partner_id)=(165) already exists.\n'
          )
        ) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: "",
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        } else {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title,
            message: Strings.popup_error_message_add,
            open: true,
            actions: (
              <div className="grid grid-cols-1 gap-2">
                <Button
                  value={"OK"}
                  className={"p-2"}
                  onClick={() => setValidation(false)}
                />
              </div>
            ),
          });
        }
      });
  };

  return (
    <>
      <Breadcrumbs items={breadcrumbItems} />

      {/* <ContentContainer containerTitle={`Add Branch`}> */}
      <BranchProfileForm
        isEditing={false}
        branchProfileData={branchProfile}
        partnerCategoryItems={partnerCategoryItems}
        contactPersonFields={contactPersonFields}
        partnerTypesItems={partnerList}
        changesMade={changesMade}
        headOfficeExists={headOfficeExists}
        headOfficeName={
          headOfficeExists
            ? headOfficeData?.getHeadOfficeByPartnerId[0]?.partnerBranch
            : ""
        }
        handleOnChange={handleOnChange}
        handleValidateFields={handleValidateFields}
        handleCancelChanges={handleCancelChanges}
        setValidation={setValidation}
        handleSaveChanges={handleSaveChanges}
      />

      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
      {/* </ContentContainer> */}
    </>
  );
};

export default AddNewBranch;
